/** Shared base classes for the dictation bubble wrapper (web + widget). */
export const BUBBLE_BASE_CLASSES = 'group relative rounded-2xl border p-5 shadow-xl';

/** Translucent surface for the default (non-error) bubble states. */
export const BUBBLE_TRANSLUCENT_CLASSES =
  'bg-surface-accent/80 backdrop-blur-sm newBrandDark:bg-surface-elevated/80';

/** Opaque surface for error states (DEV-11867): error bubbles must not show through. */
export const BUBBLE_OPAQUE_CLASSES = 'bg-surface-accent newBrandDark:bg-surface-elevated';

/**
 * Stacks above design-system dialogs (`z-50`) so the bubble stays visible during
 * onboarding and other modal flows (SCR-3645).
 */
export const DICTATION_BUBBLE_Z_INDEX_CLASS = 'z-[60]';
